import { createContext } from 'react';

/**
 * Context to store choices and functions to retrieve them.
 *
 * Use the useChoicesContext() hook to read the context.
 */
export const QueryContext = createContext( undefined );
